
export const SkeletonLoader = () => {
  return (
    <div className="w-full h-full animate-pulse relative flex justify-center">
      <div className="h-full bg-[#D7D7D7] w-full"></div>
    </div>
)};